"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  maxLength_0: 'Не более {{count}} символа. Осталось ',
  maxLength_1: 'Не более {{count}} символов. Осталось ',
  maxLength_2: 'Не более {{count}} символов. Осталось '
};